module.exports = __webpack_public_path__ + "static/img/r_010.a2da195.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic/r_010.jpg
// module id = i/VE
// module chunks = 1